import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './StaticPages.css';

const ServicesPage = () => {
    const { t } = useTranslation();

   const services = [
        { icon: 'fas fa-gavel', titleKey: 'legal', descKey: 'legal_desc_full' },
        { icon: 'fas fa-stethoscope', titleKey: 'medical', descKey: 'medical_desc_full' },
        { icon: 'fas fa-cogs', titleKey: 'technical', descKey: 'technical_desc_full' },
        { icon: 'fas fa-book-open', titleKey: 'academic', descKey: 'academic_desc_full' },
        { icon: 'fas fa-bullhorn', titleKey: 'marketing', descKey: 'marketing_desc_full' },
        { icon: 'fas fa-globe', titleKey: 'website_localization', descKey: 'website_localization_desc_full' },
        { icon: 'fas fa-mobile-alt', titleKey: 'app_localization', descKey: 'app_localization_desc_full' },
		{ icon: 'fas fa-gamepad', titleKey: 'game_localization', descKey: 'game_localization_desc_full' },
        { icon: 'fas fa-closed-captioning', titleKey: 'subtitle_translation', descKey: 'subtitle_translation_desc_full' }
    ];

    return (
        <div className="page-container static-page">
            <div className="static-header">
                <h1>{t('services_title')}</h1>
                <p>{t('services_subtitle')}</p>
            </div>
            <div className="services-grid-fullpage">
                {services.map(service => (
                    <div className="service-card-full" key={service.titleKey}>
                        <i className={service.icon}></i>
                        <h3>{t(service.titleKey)}</h3>
                        <p>{t(service.descKey)}</p>
                    </div>
                ))}
            </div>
            <div className="static-cta-section">
                <h2>{t('final_cta_title')}</h2>
                <Link to="/order" className="cta-button primary large">{t('get_instant_quote')}</Link>
            </div>
        </div>
    );
};
export default ServicesPage;